import { render, staticRenderFns } from "./fooote.vue?vue&type=template&id=28a67640&scoped=true&"
var script = {}
import style0 from "./fooote.vue?vue&type=style&index=0&id=28a67640&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a67640",
  null
  
)

export default component.exports